import { useVersionNotifierStore } from "@/store/VersionNotifierStore";

import { DsApiService } from "@/core/shared/services/DsApiService";

import type { AxiosInstance } from "axios";

export class ApiService extends DsApiService {
  /**
   * Create a new axios client
   *
   * @return {AxiosInstance} Axios instance
   */
  protected static createAxiosClient(): AxiosInstance {
    const client = super.createAxiosClient();
    const { setVersion } = useVersionNotifierStore();
    client.interceptors.response.use(
      (response) => {
        if (
          response.headers["portal-version"] &&
          response.headers["portal-version"] !== ""
        ) {
          setVersion(response.headers["portal-version"]);
        }
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
    return client;
  }
}
